<template>
  <div class="scroll-key-frame">
    <div class="section-goto-top" @click="gotoTop" :class="{show: !isTop}" :style="{ bottom : `${233 - calcScrollEnd}px`}"></div>
    <div id="Home" class="home font-project" ref="contents" :style="styleWrapper" :class="[stateFrame]">
      <section class="section-1 main-section">
        <div class="scroll-mark"></div>
        <div class="contents-wrapper" >
          <div class="type-main-title h1">
            <TypeHangul :text-data="textSrc" :backspace="true" @typeend="nextType"/>
          </div>
          <div class="type-main-description">
            <span>가비아 글꼴 프로젝트는 가비아와 대학교가 무료 글꼴을 만드는 프로젝트입니다.</span>
            <span>더 많은 분들이 온라인 공간에서 한글의 아름다움을</span>
            <span>접할 수 있도록 가비아 글꼴을 나눕니다.</span>
          </div>
        </div>
        <video autoplay muted loop playsinline poster="https://static.gabia.com/fonts/project/video/main-poster.png">
          <source src="https://static.gabia.com/fonts/project/video/main.mp4" />
        </video>
      </section>
      <section class="section-2">
        <div class="scroll-mark"></div>
        <div class="section-contents-wrapper">
          <div class="section-title" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="150">
            <span class="title">가비아 <span class="x-mark hidden collaboration"></span> 홍익대</span>
          </div>
          <div class="section-description description" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="180">
            <p>
              올해 가비아 글꼴 프로젝트에서 탄생한 가비아 고스란체와 가비아 눌체는<br>
              안병학 교수와 권순형 디자이너, 최지호 디자이너가 함께 만들었습니다.<br>
              정영훈 책임 디자이너도 지혜를 더했습니다.<br>
              1년간 수없이 다듬고 매만진 글꼴을 가비아가 모두와 나눕니다.
            </p>
          </div>
          <div class="section-contents-wrapper"  data-aos="fade-up" data-aos-duration="1000" data-aos-offset="220">
            <h4 class="section-contents-title">프로젝트 멤버</h4>
            <div class="section-contents-shapes">
                <SVGShape />
            </div>
          </div>
        </div>
      </section>
      <section class="section-3" :style="{height: `${slideKeyFrame}px`}">
        <div class="slide-container" :class="{slide: stateSlide}">
          <div class="section-contents-wrapper">
            <div class="section-title">
              <span class="title">글꼴 제작 과정</span>
            </div>
            <div class="section-contents">
              <div class="nav-font-process"></div>
              <div class="process-info" >
                <div class="process-sub font-24">{{ currentPageInfo.date }}</div>
                <div class="process-title h3">{{ currentPageInfo.title }}</div>
                <div class="process-desc font-24">{{ currentPageInfo.desc }}</div>
              </div>
            </div>
          </div>
          <div class="section-horizontal-slide-wrapper" :style="{transform: `translate3d(-${this.sliderOffset}px, 0, 0)`}">
            <div class="slide-page" v-for="step in fontProcessStep" :key="step.step" :class="`step-${step.step}`">
              <div class="contents-card" :class="`step-${step.step}-1`" :style="{top: `${step.image1.top}`, left: `${step.image1.left}` }">
                <img :src="`https://static.gabia.com/fonts/project/image/font_process/2024/${step.image1.name}.png`" :alt="step.image1.name" >
              </div>
              <div class="contents-card" :class="`step-${step.step}-2`" :style="{top: `${step.image2.top}`, left: `${step.image2.left}` }">
                <img :src="`https://static.gabia.com/fonts/project/image/font_process/2024/${step.image2.name}.png`" :alt="step.image2.name" >
              </div>
            </div>
          </div>
          <div class="scroll-mark"></div>
        </div>
      </section>
      <section class="section-4">
        <div class="section-contents-wrapper">
          <!--        <div class="section-title title" data-aos="fade-up" data-aos-offset="200">가비아 <span class="hidden collaboration"></span> 홍익대</div>-->
          <div class="section-title" data-aos="fade-up" data-aos-offset="150">
            <span class="title">완성 글꼴 보기</span>
          </div>
          <div class="section-description description" data-aos="fade-up" data-aos-offset="180">
            <p>
              가비아 고스란체는 부리체의 뼈대에 손글씨의 온도를 덧붙인 부리 계열 본문용 글꼴입니다.<br />
              가비아 눌체는 타자기체를 현대적으로 해석한 부리 계열 완성형 글꼴입니다.
            </p>
          </div>
          <div class="section-contents" style="width: 900px" data-aos="fade-up" data-aos-offset="200">
            <div class="project-font gosran h2">
              진심을 눌러 담아 써내려간 손글씨<br>
              <a class="orange" @click="moveNewFont('#font-1')">가비아 고스란체</a><br>
            </div>
            <div class="project-font null h2">
              타자기체 특유의 어수룩한 인상<br>
              <a class="purple" @click="moveNewFont('#font-2')">가비아 눌체</a><br>
            </div>
<!--            <div class="project-font cheongyeon h2 vertical-text ">햇빛과 달빛이<br> 강가에 닿아<br> 이는 잔물결<br>처럼 우리<br> 만남은<br>-->
<!--              <a class="green" @click="moveNewFont('#font-2')">청연</a>하다. </div>-->
          </div>

        </div>
      </section>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import TypeHangul from '@/Modules/TypeHangul/TypeHangul.vue';
import SVGShape from '@/components/ProjectMember.vue';

const wH = 1080;

export default {
  name: 'Home',
  components: { Footer, TypeHangul, SVGShape },
  data() {
    return {
      srcCount: 0,
      textSrc: '',
      sourceList: [
        '누구나 자유롭게 ',
        '함께 만들어가는 ',
        '가비아 글꼴 프로젝트 ',
      ],
      scrollTop: 0,
      sliderOffset: 0,
      slideKeyFrame: 5000,
      stateSlide: false,
      stateFrame: 'ready',
      fontProcessStep: [
        {
          step: 1,
          date: '2023년 2 - 4월',
          title: '글꼴 선정',
          desc: '콘셉트 보완',
          image1: { name: 'font_process_1', top: '50%', left: '64%' },
          image2: { name: 'font_process_2', top: '30%', left: '45%' },
        },
        {
          step: 2,
          date: '2023년 5 - 10월',
          title: '글꼴 디자인',
          desc: '글꼴 파생',
          image1: { name: 'font_process_3', top: '45%', left: '29%' },
          image2: { name: 'font_process_4', top: '30%', left: '60%' },
        },
        {
          step: 3,
          date: '2023년 11 - 12월',
          title: '글꼴 보완',
          desc: '중간 테스트',
          image1: { name: 'font_process_5', top: '38%', left: '35%' },
          image2: { name: 'font_process_6', top: '30%', left: '60%' },
        },
        {
          step: 4,
          date: '2024년 1월',
          title: '글꼴 완성',
          desc: '글꼴 검수',
          image1: { name: 'font_process_7', top: '27%', left: '53%' },
          image2: { name: 'font_process_8', top: '45%', left: '30%' },
        },
        {
          step: 5,
          date: '2024년 2 - 3월',
          title: '글꼴보기집 제작',
          desc: '글꼴 배포',
          image1: { name: 'font_process_9', top: '32%', left: '45%' },
          image2: { name: 'font_process_10', top: '50%', left: '58%' },
        },
      ],
    };
  },
  computed: {
    styleWrapper() {
      return {
        transform: `translate3d(0, -${this.scrollTop}px, 0)`,
      };
    },
    currentPageInfo() {
      const currentIndex = this.sliderOffset / this.wSize.wW - Math.floor(this.sliderOffset / this.wSize.wW) > 0.9
        ? Math.ceil(this.sliderOffset / this.wSize.wW) : Math.floor(this.sliderOffset / this.wSize.wW);
      return this.fontProcessStep[currentIndex];
    },
    wSize() {
      return { wW: window.innerWidth, wH: window.innerHeight };
    },
    isTop() {
      return this.scrollTop === 0;
    },
    calcScrollEnd() {
      const calcValue = document.documentElement.scrollHeight - this.wSize.wH - this.scrollTop;
      return calcValue > 233 ? 233 : calcValue;
    },
  },
  created() {
    this.textSrc = this.sourceList[this.srcCount];
    this.slideKeyFrame = this.wSize.wW * (this.fontProcessStep.length - 1) + wH;
  },
  mounted() {
    document.body.style.height = `${this.$el.parentElement.scrollHeight}px`;
    document.addEventListener('scroll', this.setScrollHandler);
    window.addEventListener('resize', this.setResizeHandler);
  },
  destroyed() {
    document.removeEventListener('scroll', this.setScrollHandler);
    window.removeEventListener('resize', this.setResizeHandler);
  },
  methods: {
    nextType() {
      this.srcCount = (this.srcCount + 1) % this.sourceList.length;
      setTimeout(() => {
        this.textSrc = this.sourceList[this.srcCount];
      }, 1000);
    },
    setScrollHandler() {
      const container = document.querySelector('.slide-container');
      const slider = document.querySelector('.section-horizontal-slide-wrapper');
      const keyFrame = document.documentElement.scrollTop;
      this.scrollTop = keyFrame;
      if (keyFrame <= 0) {
        this.stateFrame = 'ready';
      } else {
        this.stateFrame = 'start';
      }
      if (keyFrame > wH * 2 && (wH) + this.slideKeyFrame >= keyFrame) {
        this.stateSlide = true;
        container.classList.add('slide');
        this.sliderOffset = keyFrame - (wH * 2);
        // container.style.position = 'fixed';
        container.style.transform = `translate3d(0, ${keyFrame - (wH * 2)}px, 0)`;
        slider.style.transform = `translate3d(-${keyFrame - (wH * 2)}px, 0, 0)`;
      } else {
        container.classList.remove('slide');
        // this.stateSlide = false;
      }
    },
    setResizeHandler() {
      this.slideKeyFrame = this.wSize.wW * this.fontProcessStep.length;
      document.body.style.height = `${this.$el.parentElement.scrollHeight}px`;
    },
    gotoTop() {
      const { contents } = this.$refs;
      document.documentElement.scrollTop = 0;
      contents.style.transition = 'transform 1000ms';
      contents.addEventListener('transitionend', () => {
        contents.style.transition = '';
      });
      this.scrollTop = 0;
    },
    moveNewFont(name) {
      this.$router.push({ name: 'Font2024', params: { target: name } });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-goto-top {
  cursor: pointer;
  position: fixed;
  width: 56px;
  height: 56px;
  border: 1px solid #0a0a0a;
  z-index: 9999;
  right: 40px;
  bottom: 40px;
  background-color: #fff;
  transition: opacity 500ms;
  opacity: 0;
  margin-bottom: 30px;
  &.show {
    transition: opacity 1000ms;
    opacity: 1;
  }
  &:before {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-top: 1px solid #0a0a0a;
    border-left: 1px solid #0a0a0a;
    top: 31%;
    left: 50%;
    transform: translate(-50%, 0) rotate(45deg);
  }
  &:after {
    content: '';
    position: absolute;
    height: 26px;
    border-left: 1px solid #0a0a0a;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
  #Home {
    section {
      text-align: center;
    }
    .section-1 {
      .contents-wrapper {
        .type-main-description {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  .vertical-text {
    a {
      font-size: inherit;
      font-family: inherit;
      color: #72CE16;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        height: 100%;
        border-bottom: 1px solid #000000;

      }
    }
  }
  .project-font {
    font-size: 58px;
    &.maeumgyeol {
      line-height: 100px;
    }
    &.cheongyeon {
      line-height: 2.4;
    }
    a {
      cursor: pointer;
      font-size: inherit;
      font-family: inherit;
      color: #72CE16;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        height: 100%;
        border-bottom: 1px solid #000000;

      }
      &.green {
        color: #4CE39B;
        border-bottom: 2px solid #4CE39B;
      }
      &.red {
        color: #FA8BA0;
        border-bottom: 2px solid #FA8BA0;
      }
      &.orange {
        color: #FDB755;
        border-bottom: 2px solid #FDB755;
      }
      &.purple {
        color: #8B94FF;
        border-bottom: 2px solid #8B94FF;
      }
    }
  }
  .section-2 {
    .section-contents-wrapper {
      width: 1100px;
      margin: 0 auto;
      .section-contents-title {
        margin-bottom: 60px;
      }
    }
    .scroll-mark {
      bottom: 0;
    }
  }
  .section-3 {
    padding: 0;
    .slide-container {
      position: relative;
      width: 100%;
      height: 1080px;
      background: url('https://static.gabia.com/fonts/project/image/noise_bg.png') repeat center center;
      &.slide {
      }
    }
    .section-contents {
      text-align: left;
      width: 1180px;
      margin: 0 auto;
      .nav-font-process {
        height: 90px;
      }
      .process-info {
        .process-sub {
          margin-bottom: 35px;
        }
        .process-desc {
          margin-top: 15px;
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
    .section-contents-wrapper {
      padding: 100px 40px;
      position: absolute;
      width: 100%;
      z-index: 100;
    }
    .section-horizontal-slide-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-shrink: 0;
      .slide-page {
        width: 100%;
        flex-shrink: 0;
        position: relative;
        .contents-card {
          position: absolute;
          width: 640px;
          height: 480px;
          margin: 20px;
        }
      }
    }
    .scroll-mark {
      bottom: 0;
    }
  }
</style>
